import { PUBLIC_JOB_DETAIL_URL } from './const';
import { PublicJobDetailResponseData } from './types';
import { preloadedGET } from '../../../utils/preloadApi';

export async function fetchDetailData(id: string) {
	const response = await preloadedGET<PublicJobDetailResponseData>(PUBLIC_JOB_DETAIL_URL, {
		params: { id },
	});

	return response.data;
}
